export { Panel } from './Panel';



// WEBPACK FOOTER //
// ./src/components/Panel/index.ts